import { EToastType } from 'libs/types/site/IClient';
import { isWithinSize, prepareFile } from 'libs/utils/logic/operations/fileOperations';
import { userMessage } from 'libs/utils/logic/ui/uiLogic';
import { useEffect, useRef, useState } from 'react';
import { apiUploadAudioFile } from 'static/api/directApi';

export const useUploadFile = (
    files: File[],
    fileType: 'gpx' | 'mp3'
): {
    inProgress: number;
    uploaded: string;
} => {
    const [inProgress, setInProgress] = useState<number>(0);
    const refProgress = useRef<number>(0);
    const [uploaded, setUploaded] = useState<string>();
    const mountedRef = useRef<boolean>();

    useEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        if (files) {
            const file = files[0];
            if (!file) return;
            refProgress.current += 1;
            setInProgress(refProgress.current);

            if (!isWithinSize(file.size, 25)) {
                userMessage(EToastType.ERROR, 'Localization.ERROR_FILE_LARGE');
                setInProgress(refProgress.current - 1);
                refProgress.current -= 1;
            } else {
                const formData = prepareFile(file, fileType);
                apiUploadAudioFile(formData).then((r) => {
                    if (mountedRef.current) {
                        setUploaded(r['data']['url']);
                        setInProgress(refProgress.current - 1);
                        refProgress.current -= 1;
                    }
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [files]);

    return { inProgress, uploaded };
};
